import { QueryClient } from '@tanstack/react-query'

/**
 * The app's one React Query client. Its own module (not main.jsx) so the
 * store can clear it when the session or tenant changes
 * (store/clearQueryCacheOnSessionChange.js) - older query keys don't all
 * carry the tenant id, so a cached page of one tenant's rows could
 * otherwise render for the next.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})
